export const fields = [
  {
    id: "companyName",
    label: "Company Name",
  },
  {
    id: "location",
    label: "Location",
  },
  {
    id: "Incorporationdate",
    label: "Incorporation Date",
  },
   {
    id: "TotalPaidUpPremiumtoShares",
    label: "Total Paid Up Premium to Shares",
  },
  {
    id: "TotalPaidUpCapital",
    label: "Total Paid Up Capital",
  },
  {
    id: "ParValueofShares",
    label: "Par Value of Shares",
  },
  {
    id: "AuthorizedCapital",
    label: "Authorized Capital",
  },
  {
    id: "totalNoOfShares",
    label: "Total No Of Shares",
  },
  {
    id: "directors",
    label: "Directors",
  },
  {
    id: "ManagingDirector",
    label: "Managing Director",
  },
  {
    id: "DeputyManagingDirector",
    label: "Deputy Managing Director",
  },
  {
    id: "Chairman",
    label: "Chairman",
  },
  {
    id: "DeputyChairman",
    label: "Deputy Chairman",
  },
  {
    id: "CompanySecretary",
    label: "Company Secretary",
  },
  {
    id: "StatutoryAuditor",
    label: "Statutory Auditor",
  },
  {
    id: "RepresentativeDirector",
    label: "Representative Director",
  },
  {
    id: "LegalRepresentative",
    label: "Legal Representative",
  },
  {
    id: "Remarks",
    label: "Remarks",
  },
  {
    id: "shareholders",
    label: "Shareholders",
  }
];
